import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Home from "./Pages/Home";
import ExploreCarrers from "./Pages/ExploreCarrers";
import { JobDetailPage } from "./components";
import MeetScheduler from "./Pages/MeetScheduler";
import Career from "./Pages/Career";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import TermsOfServices from "./Pages/TermsOfServices";
import Assignment from "./Pages/Assignment";
import NotFound from "./Pages/NotFound";
import Blogs from "./Pages/Blogs";
import BlogDetailPage from "./Pages/BlogDetailPage";

import CoalerBody from "./components/coaler/components/CoalerBody";
import GetEarlyAccess from "./components/coaler/components/GetEarlyAccess";
import CoalerApp from "./components/coaler/components/CoalerApp";
import Support from "./components/Support";
import SignORoutes from "./components/signO/SignORoutes";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,

    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/explorecareers",
        element: <ExploreCarrers />,
      },
      {
        path: "/careers",
        element: <Career />,
      },
      {
        path: "/scheduler",
        element: <MeetScheduler />,
      },
      {
        path: "/careers/:jobId",
        element: <JobDetailPage />,
      },
      {
        path: "/privacyPolicy",
        element: <PrivacyPolicy />,
      },
      {
        path: "/termsofservices",
        element: <TermsOfServices />,
      },
      {
        path: "/assignment",
        element: <Assignment />,
      },
      {
        path: "/blogs",
        element: <Blogs />,
      },
      {
        path: "/blogs/:id",
        element: <BlogDetailPage />,
      },
      {
        path: "/support",
        element: <Support />,
      },
      {
        path: "/sign-o/*",
        element: <SignORoutes />,
      },
      {
        path: "*",
        element: <NotFound />,
      },

      // {
      //   path: "/coaler",
      //   element: <CoalerBody />,
      // },
      {
        path: "/coaler",
        element: <CoalerApp />,
        children: [
          {
            index: true,
            element: <CoalerBody />,
          },
          {
            path: "get-early-access",
            element: <GetEarlyAccess />,
          },
        ],
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
